<template>
  <div class="partner">
    <h6 class="partner__title">多品类高端产品资源</h6>
    <h6 class="partner__desc">丰富高端的产品资源+行业内低价优势</h6>
    <div class="home__partner">
      <div class="">
        <ul class="home__partner-cruise-company">
          <div class="item__wrapper" v-for="(item, index) in list" :key="index">
            <li class="home__partner-cruise-item" :class="{
            'is-active': index == activeIndex
          }" @mouseenter="handleHover(index)">

              <div v-if="index != activeIndex" class="cover" :style="{ backgroundImage: `url(${item.mini_bg})` }">
                <h6 class="cover-title">{{ item.name }}</h6>
                <p class="cover-desc line-clamp-1" v-html="item.desc"></p>
              </div>

              <div class="slider__opend" v-else :style="{ backgroundImage: `url(${item.logo})` }" @click="clickBanner(item)">
                <h6 class="slider__opend__title">{{ item.name }}</h6>
                <p class="slider__opend__desc">{{ item.desc }}</p>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
    <div class="partner__btn">
      <nuxt-link :to="moreBtnLink" class="btn">
        查看更多
        <i class="ficon ficon-right" />
      </nuxt-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: 0,
      list: [
        {
          logo: require("@/assets/img/home/resource_1.png"),
          mini_bg: require("@/assets/img/home/resource_min_1.png"),
          name: "长江游轮",
          desc: "纵览古今，中国之美，美在三峡，山水环绕，峡谷连绵",
          to: "/resource/product/list/cruise?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
          custom_to: "/customer/list?cruise[0]=309&cruise[1]=2&cruise[2]=326&cruise[3]=35",
        },
        {
          logo: require("@/assets/img/home/resource_2.png"),
          mini_bg: require("@/assets/img/home/resource_min_2.png"),
          name: "海洋邮轮",
          desc: "遍布世界各地，从寻常到奢华，从江河到海洋、从观光到探险",
          to: "/resource/product/list/cruise?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
          custom_to: "/customer/list?cruise[0]=308&cruise[1]=83&cruise[2]=204&cruise[3]=211&cruise[4]=111",
        },
        {
          logo: require("@/assets/img/home/resource_3.png"),
          mini_bg: require("@/assets/img/home/resource_min_3.png"),
          name: "松赞旅行",
          desc: "领略极致风光、感受神山文化、倾听藏地文明、寻味地道美食",
          to: "/resource/product/list/vacation?keywords=松赞旅行",
          custom_to: "/customer/list?keyword=松赞旅行",
        },
        {
          logo: require("@/assets/img/home/resource_4.png"),
          mini_bg: require("@/assets/img/home/resource_min_4.png"),
          name: "豪华专列",
          desc: "大美北疆，圆梦丝路。避暑东北，88人的诗与远方",
          to: "/resource/product/list/vacation?keywords=车",
          custom_to: "/customer/list?keyword=车",
        },
        {
          logo: require("@/assets/img/home/resource_5.png"),
          mini_bg: require("@/assets/img/home/resource_min_5.png"),
          name: "Club Med",
          desc: "一价全包、应有尽有、精致奢华的完美假期。丽江、桂林、三亚、北京、...",
          to: "/resource/product/list/vacation?keywords=Club Med",
          custom_to: "/customer/list?keyword=Club Med",
        },
      ],
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
    moreBtnLink() { // 查看更多 跳转 地址
      return '/product'
      // return this.isDistributor ? "/resource/product/list/cruise" : '/customer/list'
    },
  },
  methods: {
    handleHover(index) {
      this.activeIndex = index;
    },
    clickBanner(banner) {
      if (!this.isDistributor) {
        // this.$router.push("/customer/list");
        this.$router.push(banner.custom_to);
      } else {
        this.$router.push(banner.to);
      }
    },
  },
};
</script>
<style lang="scss" scoped>

@import "@/assets/scss/base/_mixins";
@import "@/assets/scss/base/_var";

.partner {
  background: linear-gradient(180deg, #f1f3f5 0%, #ffffff 100%);
  padding-top: 118px;
  &__title {
    color: #212529;
    font-size: 40px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 5px;
  }
  &__desc {
    color: #adb5bd;
    text-align: center;
    font-size: 22px;
  }
  &__btn {
    display: flex;
    justify-content: center;
    padding-bottom: 90px;
    .btn {
      width: 172px;
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 8px;
      color: #495057;
      font-size: 20px;
      font-weight: 500;
      border: 1px solid #adb5bd;
      user-select: none;
      cursor: pointer;
      transition: 0.3s all ease;
      .ficon {
        margin-left: 5px;
        position: relative;
        left: 0;
        color: #adb5bd;
      }
      &:hover {
        background-color: #f25b3b;
        border-color: #f25b3b;
        color: #fff;
        .ficon {
          animation: finger infinite 2s;
          color: #fff;
        }
      }
    }
  }
}

.home {
  &__partner {
    width: 1082px;
    margin: 0 auto;
    padding-bottom: 100px;
    &-cruise-company {
      @include clearfix;
      margin-top: 100px;
    }
    &-cruise-item {
      float: left;
      width: 126px;
      height: 345px;
      background: #fff;
      margin-left: 18px;
      transition: all $primary-transition;
      cursor: pointer;
      overflow: hidden;
      border-radius: 11px;

      &:first-child {
        margin: 0;
      }
      .cover {
        width: 126px;
        height: 345px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        color: #fff;
        padding: 20px 8px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
        &-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 2px;
          position: relative;
        }
        &-desc {
          position: relative;
          font-size: 12px;
          font-weight: 600;
          padding-left: 2px;
        }
      }

      &.is-active {
        width: 505px;
        height: 345px;
      }
    }
  }
}
.slider__opend {
  width: 505px;
  height: 345px;
  position: relative;
  background-position: center;
  background-size: cover;
  padding: 20px;
  cursor: pointer;
  color: #fff;
  &__title {
    font-size: 29px;
    font-weight: 600;
    margin-bottom: 2px;
    position: relative;
  }
  &__desc {
    position: relative;
    font-size: 13px;
    font-weight: 600;
  }
}
.item__wrapper {
  float: left;
  margin-left: 18px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -20px;
    width: 100%;
    height: 8px;
    background-color: #868e96;
    filter: blur(11.700000000000001px);
  }

  &:first-child {
    margin: 0;
  }
}

@keyframes finger {
  0% {
    transform: translate(0);
  }

  25% {
    transform: translate(10px);
  }

  50% {
    transform: translate(0);
  }

  75% {
    transform: translate(10px);
  }

  100% {
    transform: translate(0);
  }
}

</style>